export interface BookingAppointment {
    id: string;
    service: {
        id: string;
        label: string;
        price: string;
        icon: string;
    };
    vet: {
        id: number;
        name: string;
        specialty: string;
    };
    date: string;
    time: string;
    owner: string;
    pet: string;
    status: 'PENDING' | 'CONFIRMED' | 'ANAMNESA' | 'MEDICAL_RECORD_COMPLETED' | 'CANCELLED';
    createdAt: string;
}

const BOOKINGS_KEY = 'petcare_bookings';

export const getBookingsFromStorage = (): BookingAppointment[] => {
    try {
        const data = localStorage.getItem(BOOKINGS_KEY);
        return data ? JSON.parse(data) : [];
    } catch {
        return [];
    }
};

export const saveBookingsToStorage = (bookings: BookingAppointment[]): void => {
    localStorage.setItem(BOOKINGS_KEY, JSON.stringify(bookings));
};

export const addBookingToStorage = (booking: BookingAppointment): void => {
    const bookings = getBookingsFromStorage();
    bookings.push(booking);
    saveBookingsToStorage(bookings);
};

export const deleteBookingFromStorage = (id: string): void => {
    const bookings = getBookingsFromStorage();
    const filtered = bookings.filter(b => b.id !== id);
    saveBookingsToStorage(filtered);
};

export const updateBookingInStorage = (id: string, updates: Partial<BookingAppointment>): void => {
    const bookings = getBookingsFromStorage();
    const updated = bookings.map(b => b.id === id ? { ...b, ...updates } : b);
    saveBookingsToStorage(updated);
};
